import { type UseQueryOptions, useQuery } from '@tanstack/react-query';

import type { PageableContent, Sort, TimestampInMillis, Trip, UUID } from '@cobliteam/common-types';

import { GraphQLCameraTripRequester } from '@cobliteam/api-lib';

import useUser from '../../useEntity/useUser';

const cameraTripRequester = new GraphQLCameraTripRequester();

const QUERY_KEY = 'CAMERA-TRIP';

const useCameraTrip = () => {
  const { getSession } = useUser();
  const fleetId = getSession().fleet.id;

  const getCameraTrip = (
    vehicleId: UUID,
    fromTimestamp?: TimestampInMillis,
    toTimestamp?: TimestampInMillis,
    footageAvailabilityStatus?: boolean[],
    page?: number,
    size?: number,
    sort?: Sort,
    options?: Partial<UseQueryOptions<PageableContent<Trip>>>
  ) => {
    return useQuery<PageableContent<Trip>>({
      queryKey: [QUERY_KEY, fleetId, vehicleId, fromTimestamp, toTimestamp, JSON.stringify(footageAvailabilityStatus), page, size, sort],
      queryFn: () => cameraTripRequester.getTripPage(vehicleId, fromTimestamp, toTimestamp, footageAvailabilityStatus, page, size, sort),
      retry: false,
      enabled: true,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: 300000,
      ...options,
    });
  };

  return {
    getCameraTrip,
  };
};

export default useCameraTrip;
